// @ts-nocheck
export const convertFileToBase64 = (file: File) => {
    return new Promise(function (resolve, reject) {
        const fr = new FileReader();

        fr.onload = function () {
            resolve(fr.result);
        };

        fr.onerror = function () {
            reject(fr);
        };

        fr.readAsDataURL(file);
    });
};
